import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import type DIWMap from './diw.map';

export default class DIWMapForm extends TKCustomElementFactory {
    private mapComponent?: DIWMap;
    private select?: HTMLSelectElement;

    constructor() {
        super();
    }

    async connectedCallback(): Promise<void> {
        await customElements.whenDefined('diw-map');

        this.mapComponent = document.querySelector<DIWMap>('diw-map') || undefined;
        this.select = document.querySelector<HTMLSelectElement>('[data-tk-mapstyleselector]') || undefined;

        if (!this.mapComponent) throw new Error('DIWMapForm: Map Component not found');
        if (!this.select) throw new Error('DIWMapForm: Map style selector not found');

        this.attachEventListeners();
    }

    private attachEventListeners(): void {
        const action = this.handleMapStyleChange.bind(this);
        this.pushListener({ element: this.select!, event: 'change', action });
    }

    private handleMapStyleChange(): void {
        const newStyle = this.select!.value;

        this.mapComponent!.updateMapStyle(newStyle);
    }
}
